import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Alert, Col, Input, PageHeader, Row, Spin, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ButtonItem,
  DynamicCardForm,
  ErrorItem,
  Form,
  FormItem,
  InputItem,
  InputNumberItem,
  TextAreaItem,
} from "../../../../Components/Items";

// Configuración del RMA de compras: folio, plazo de garantía (solo aviso), lista de motivos
// y condiciones que salen en el PDF que se le manda al proveedor.
class ConfiguracionRMACompra extends Component {
  formRef = React.createRef();
  state = {
    loading: true,
    puedeConfigurar: false,
    motivos: [],
    motivoNuevo: "",
  };

  componentDidMount() {
    this.consultar();
  }

  consultar() {
    this.setState({ loading: true });
    axios
      .post("rmaCompra/datosConfiguracionRMACompra", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success !== 2) {
          this.setState({ loading: false });
          return message.error("No se pudo leer la configuración de RMA de compras");
        }
        const configuracion = res.data.configuracion;
        this.setState({ loading: false, puedeConfigurar: res.data.puedeConfigurar, motivos: configuracion.motivos || [] });
        this.formRef.current?.setFieldsValue({
          serie: configuracion.serie,
          siguienteNumero: configuracion.siguienteNumero,
          diasPlazo: configuracion.diasPlazo,
          instruccionesProveedor: configuracion.instruccionesProveedor,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("No se pudo leer la configuración de RMA de compras");
      });
  }

  agregarMotivo() {
    const texto = this.state.motivoNuevo.trim();
    if (!texto) return;
    if (this.state.motivos.some((motivo) => motivo.toLowerCase() === texto.toLowerCase())) {
      return message.info("Ese motivo ya está en la lista");
    }
    this.setState((anterior) => ({ motivos: [...anterior.motivos, texto], motivoNuevo: "" }));
  }

  async guardar() {
    let valores;
    try {
      valores = await this.formRef.current.validateFields();
    } catch (e) {
      return ErrorItem(e);
    }
    if (this.state.motivos.length === 0) return message.warning("Deja al menos un motivo");

    this.setState({ loading: true });
    axios
      .post(
        "rmaCompra/guardarConfiguracionRMACompra",
        {
          empresaId: this.props.empresaId,
          serie: valores.serie,
          siguienteNumero: valores.siguienteNumero,
          // null explícito = sin plazo (JSON.stringify borra los undefined)
          diasPlazo: valores.diasPlazo === undefined || valores.diasPlazo === "" ? null : valores.diasPlazo,
          motivos: this.state.motivos,
          instruccionesProveedor: valores.instruccionesProveedor || "",
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se guardó la configuración de RMA de compras");
          this.consultar();
        } else {
          message.error(res.data.message || "No se pudo guardar la configuración");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("No se pudo guardar la configuración");
      });
  }

  render() {
    const soloLectura = !this.state.puedeConfigurar;
    return (
      <>
        <PageHeader
          onBack={() => this.props.history.goBack()}
          title="Configuración de RMA de compras"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
        />
        <Spin spinning={this.state.loading}>
          {soloLectura && !this.state.loading && (
            <Alert type="info" showIcon style={{ marginBottom: 10 }} message="Solo un administrador puede cambiar esta configuración." />
          )}
          <Form ref={this.formRef} name="ConfiguracionRMACompra" layoutForm="vertical">
            <Row gutter={16}>
              <DynamicCardForm title="Folio" xs={24} lg={12}>
                <Row gutter={16}>
                  <Col xs={12}>
                    <FormItem label="Serie" name="serie" required margin>
                      <InputItem placeholder="RMAC" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                  <Col xs={12}>
                    <FormItem
                      label="Siguiente folio"
                      name="siguienteNumero"
                      required
                      tooltip={{ title: "El número que tomará el siguiente RMA. Los folios cancelados no se reutilizan." }}
                      margin
                    >
                      <InputNumberItem min={1} precision={0} style={{ width: "100%" }} disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
              </DynamicCardForm>

              <DynamicCardForm title="Plazo de garantía" xs={24} lg={12}>
                <FormItem
                  label="Días desde la compra"
                  name="diasPlazo"
                  tooltip={{
                    title:
                      "Si la compra más antigua del RMA tiene más días que este plazo, el RMA avisa que está fuera de garantía. No bloquea: el proveedor decide. Vacío = sin aviso.",
                  }}
                  margin
                >
                  <InputNumberItem min={0} precision={0} placeholder="Sin plazo" style={{ width: "100%" }} disabled={soloLectura} />
                </FormItem>
              </DynamicCardForm>

              <DynamicCardForm title="Motivos de devolución" xs={24} lg={12}>
                {this.state.motivos.map((motivo, indice) => (
                  <div key={motivo} style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 8 }}>
                    <div style={{ flex: 1 }}>{motivo}</div>
                    {!soloLectura && (
                      <ButtonItem
                        type="default"
                        size="small"
                        rojo
                        icon={<DeleteOutlined />}
                        onClick={() =>
                          this.setState((anterior) => ({ motivos: anterior.motivos.filter((_, i) => i !== indice) }))
                        }
                      />
                    )}
                  </div>
                ))}
                {!soloLectura && (
                  <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
                    <Input
                      value={this.state.motivoNuevo}
                      placeholder="Nuevo motivo"
                      onChange={(e) => this.setState({ motivoNuevo: e.target.value })}
                      onPressEnter={(e) => {
                        e.preventDefault();
                        this.agregarMotivo();
                      }}
                    />
                    <ButtonItem type="default" icon={<PlusOutlined />} onClick={this.agregarMotivo.bind(this)}>
                      Agregar
                    </ButtonItem>
                  </div>
                )}
              </DynamicCardForm>

              <DynamicCardForm title="Condiciones para el proveedor (PDF)" xs={24} lg={12}>
                <FormItem name="instruccionesProveedor" margin>
                  <TextAreaItem
                    rows={6}
                    placeholder="Qué esperas del proveedor: plazo para responder, a quién mandar el número de autorización, cómo se recogerá o enviará la mercancía, etc."
                    disabled={soloLectura}
                  />
                </FormItem>
              </DynamicCardForm>
            </Row>
            {!soloLectura && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "14px 16px",
                  background: "white",
                  borderRadius: 8,
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                }}
              >
                <ButtonItem type="primary" onClick={this.guardar.bind(this)}>
                  Guardar configuración
                </ButtonItem>
              </div>
            )}
          </Form>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ConfiguracionRMACompra);
